import script from "./GoogleFilePicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./GoogleFilePicker.vue?vue&type=script&setup=true&lang=ts"

import "./GoogleFilePicker.vue?vue&type=style&index=0&id=978f21c2&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-978f21c2"]])

export default __exports__